import { render, staticRenderFns } from "./TextSectionView.vue?vue&type=template&id=30c513bc"
import script from "./TextSectionView.vue?vue&type=script&lang=js"
export * from "./TextSectionView.vue?vue&type=script&lang=js"
import style0 from "./TextSectionView.vue?vue&type=style&index=0&id=30c513bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports